import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Box, Paper, Tab, Tabs, Typography, makeStyles } from '@material-ui/core';
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import { setPanelDeliveryReports } from '../../redux/actions/panelDeliveryReportsAction';
import { PackageDeliveredPage } from '../fullPackageDelivered';

const DELIVERY_MODES = {
    partial: 'partial',
    full: 'full',
    both: 'both',
};

const TAB_OPTIONS = [
    { value: DELIVERY_MODES.both, label: 'Both' },
    { value: DELIVERY_MODES.full, label: 'Full Delivery Details' },
    { value: DELIVERY_MODES.partial, label: 'Partial Delivery Details' },
];

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(1, 2, 2),
        backgroundColor: '#f4f6f8',
        minHeight: '100%',
    },
    pageCard: {
        border: '1px solid #e8edf3',
        borderRadius: theme.spacing(0.75),
        backgroundColor: '#fff',
        overflow: 'hidden',
    },
    pageHeader: {
        padding: theme.spacing(1.5, 2, 0),
    },
    heading: {
        fontWeight: 700,
        color: '#1C375D',
        fontSize: 22,
        lineHeight: 1.2,
    },
    tabsRoot: {
        minHeight: 44,
        marginTop: theme.spacing(0.5),
        borderBottom: '1px solid #e8edf3',
        '& .MuiTab-root': {
            minHeight: 44,
            padding: theme.spacing(0, 2),
        },
        '& .MuiTabs-indicator': {
            height: 3,
            borderRadius: '3px 3px 0 0',
        },
    },
    tab: {
        textTransform: 'none',
        fontWeight: 600,
        minWidth: 168,
        fontSize: 13,
        color: '#5c6b7a',
        '&.Mui-selected': {
            color: '#1C375D',
        },
    },
    pageContent: {
        padding: theme.spacing(0, 2, 2),
    },
}));

const resolveDeliveryMode = (search) => {
    const params = new URLSearchParams(search);
    const tab = params.get('tab') || params.get('mode');
    if (tab === DELIVERY_MODES.partial) return DELIVERY_MODES.partial;
    if (tab === DELIVERY_MODES.full) return DELIVERY_MODES.full;
    return DELIVERY_MODES.both;
};

const PanelDeliveryReports = (props) => {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const [deliveryMode, setDeliveryMode] = useState(() => resolveDeliveryMode(location.search));

    useEffect(() => {
        setDeliveryMode(resolveDeliveryMode(location.search));
    }, [location.search]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const tab = params.get('tab') || params.get('mode');
        if (!tab) {
            params.set('tab', DELIVERY_MODES.both);
            history.replace({
                pathname: location.pathname,
                search: params.toString(),
            });
        }
    }, [history, location.pathname, location.search]);

    const handleTabChange = (event, value) => {
        setDeliveryMode(value);
        const params = new URLSearchParams(location.search);
        params.set('tab', value);
        history.replace({
            pathname: location.pathname,
            search: params.toString(),
        });
    };

    return (
        <div className={classes.root}>
            <Paper className={classes.pageCard} elevation={0}>
                <Box className={classes.pageHeader}>
                    <Typography variant="h5" className={classes.heading}>
                        Panel Delivery Reports
                    </Typography>
                    <Tabs
                        value={deliveryMode}
                        onChange={handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        className={classes.tabsRoot}
                    >
                        {TAB_OPTIONS.map((tab) => (
                            <Tab
                                key={tab.value}
                                label={tab.label}
                                value={tab.value}
                                className={classes.tab}
                            />
                        ))}
                    </Tabs>
                </Box>

                <Box className={classes.pageContent}>
                    <PackageDeliveredPage
                        key={deliveryMode}
                        mode={deliveryMode}
                        hidePageTitle
                        embedded
                        {...props}
                    />
                </Box>
            </Paper>
        </div>
    );
};

const mapStateToProps = (state) => ({
    userDetails: state.user?.userDetails || {},
    panelDeliveryReports: state.panelDeliveryReports,
});

export default connect(mapStateToProps, {
    setLoading,
    setSnackInfo,
    setPanelDeliveryReports,
})(PanelDeliveryReports);
